module.exports = __webpack_public_path__ + "img/base_hebergements_insolite.f6fbd491.svg";